// const BASE_URL = "https://localhost:7231/api/Allowance";
// const BASE_URL = "https://patmitracbs.in/api/Allowance";

import { BASE_URL } from "../config";

export const getAllAllowance = async () => {
  try {
    const response = await fetch(`${BASE_URL}/Allowance/allowances`);
    if (!response.ok) {
      throw new Error("Failed to fetch allowances");
    }
    return await response.json();
  } catch (error) {
    console.error("Error fetching allowances:", error);
    throw error;
  }
};


// export const updateAllowance = async (id, allowance) => {
//   try {
//     const response = await fetch(`${BASE_URL}/allowances/${id}`, {
//       method: "PUT",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify(allowance),
//     });

//     if (!response.ok) {
//       throw new Error("Failed to update allowance");
//     }

//     // If 204 No Content, just return success
//     if (response.status === 204) {
//       return true;
//     }

//   } catch (error) {
//     console.error("Error updating allowance:", error);
//     throw error;
//   }
// };

export const updateAllowance = async (id, allowance) => {
  try {
    const trUser = sessionStorage.getItem("username") || "admin"; // fallback if session missing
    const trDate = new Date().toISOString();

    const response = await fetch(`${BASE_URL}/Allowance/allowances/${id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ...allowance,
        trUser: trUser,
        trDate: trDate,
      }),
    });


    if (!response.ok) {
      throw new Error("Failed to update allowance");
    }

    // If 204 No Content, just return success
    if (response.status === 204) {
      return true;
    }

    return await response.json();
  } catch (error) {
    console.error("Error updating allowance:", error);
    throw error;
  }
};


export const addAllowance = async (allowance) => {
  try {
    const crUser = sessionStorage.getItem("username") || "guest"; // fallback if missing

    const response = await fetch(`${BASE_URL}/Allowance/allowances`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ...allowance,
        crUser: crUser,
        crDate: new Date().toISOString(),
        deleted: "N",
      }),
    });

    if (!response.ok) {
      throw new Error("Failed to add allowance");
    }

    return response.status === 201 ? true : await response.json();
  } catch (error) {
    console.error("Error adding allowance:", error);
    throw error;
  }
};


export const deleteAllowance = async (id) => {
  try {
    const response = await fetch(`${BASE_URL}/Allowance/allowances/${id}`, {
      method: "DELETE",
    });

    
    if (response.status === 204) {
      return true; // successfully deleted
    } else {
      throw new Error("Failed to delete allowance");
    }
  } catch (error) {
    console.error("Error deleting allowance:", error);
    throw error;
  }
};
